import { BoobleModalService } from 'booble-modal';
import { ActivatedRoute, Router } from '@angular/router';
import { Component } from '@angular/core';

@Component({
  templateUrl: './cancel-modal.component.html',
  styleUrls: ['./cancel-modal.component.scss'],
})
export class CancelModal {
  tenant: string = '';

  constructor(
    private modalService: BoobleModalService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  goHome() {
    this.closeModal();
    this.router.navigate([`xavi-pay/home`]);
  }
}
